<template>
    <div>
        <h5 class="text-primary">
            {{ $tc('surgery.adjuvantTreatment.title', surgery.adjuvant_treatments.length) }}
            <i
                class="fas fa-pen clickable"
                style="font-size: 1rem"
                data-toggle="modal"
                @click="showModal"
            />
        </h5>
        <div
            v-for="(adjuvant, index) in surgery.adjuvant_treatments"
            :key="'adjuvant-treatment-' + index"
        >
            <div class="d-inline-flex flex-column mr-3">
                <div>
                    <label class="form-label">{{ adjuvantTreatmentFields.treatment_type.label }}:</label>
                    {{ adjuvant.treatment_type | choice(adjuvantTreatmentFields.treatment_type) }}
                </div>
                <div>
                    <label class="form-label">{{ adjuvantTreatmentFields.date.label }}:</label>
                    {{ adjuvant.date | datetime }}
                </div>
            </div>

            <div class="d-inline-flex flex-column mr-3 mb-3">
                <div>
                    <label class="form-label">{{ adjuvantTreatmentFields.dose.label }}</label>
                    {{ adjuvant.dose }}
                </div>
                <div>
                    <label class="form-label">{{ adjuvantTreatmentFields.medication_schedule.label }}</label>
                    {{ adjuvant.medication_schedule }}
                </div>

            </div>
        </div>
        <p v-if="surgery.adjuvant_treatments.length === 0">{{ $t('surgery.adjuvantTreatment.noTreatment') }}</p>


        <b-modal
            :id="modalId"
            size="xl"
            centered
            hide-header
            hide-footer
        >
            <adjuvant-treatment
                class="add-surgery-page"
                ref="adjuvanTreatment"
            />
            <p v-if="generalError" class="invalid-feedback d-block">
                {{ this.$t('error.general') }}
            </p>
            <b-button class="float-right" @click="cancel">
                {{ $t('utils.cancel') }}
            </b-button>
            <b-button class="float-right mr-3" variant="primary" @click="save">
                {{ $t('utils.save') }}
            </b-button>
        </b-modal>

    </div>
</template>
<script>
    import {mapActions, mapState} from "vuex";
    import EditableByPopupMixin from "@/components/surgery/detail/timeline/EditableByPopupMixin";
    import AdjuvantTreatment from "@/components/surgery/create/AdjuvantTreatment";
    import {logRequestError} from "@/utils/utils";

    export default {
        name: 'timeline-adjuvant-treatment',
        components: {AdjuvantTreatment},
        mixins: [EditableByPopupMixin],
        computed: {
            ...mapState(['surgery', 'adjuvantTreatmentFields']),
            index() {
                return 'adjuvant-treatment';
            },
        },
        methods: {
            ...mapActions(['updateAdjuvantTreatment']),
            async save() {
                if (await this.$refs.adjuvanTreatment.validate()) {
                    try {
                        await this.updateAdjuvantTreatment({
                            surgery: this.surgery.id,
                            data: this.surgery.adjuvant_treatments,
                        });
                        this.generalError = false;
                        this.closeModal();
                        this.$emit('save');
                    } catch (error) {
                        logRequestError(error);
                        this.generalError = true;
                    }
                }
            },
        },
    };
</script>
